import React from 'react';
import classNames from 'classnames';
import styles from './StoreButton.module.scss';

const StoreButton = ({
  store = 'apple', // 'apple' | 'google'
  className = '',
  ...rest
}) => {
  const buttonClass = classNames(styles.storeButton, className);

  const isApple = store === 'apple';
  
  const href = isApple
    ? 'https://apps.apple.com/ru/app/you-wanna/id6449462077'
    : 'https://play.google.com/store/apps/details?id=ru.youwanna.android';

  const content = (
    <div className={styles.storeButtonContent}>
      {isApple ? (
        <svg
          className={styles.storeIcon}
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.2744 8.76641C18.3199 7.35402 18.7089 5.27339 20.0629 3.90651C21.3197 2.6377 22.8497 2.01932 23.8026 1.73661C24.1705 1.62747 24.5234 1.90489 24.5053 2.2882C24.4415 3.64027 24.086 5.65695 23.1687 6.73734C22.304 7.75578 20.913 9.10631 18.8755 9.33354C18.542 9.37073 18.2636 9.10179 18.2744 8.76641Z"
            fill="currentColor"
          />
          <path
            d="M21.7631 34.6177C22.7415 34.9925 23.7307 35.3714 24.626 35.3714C26.5412 35.3714 32.118 30.9527 32.3189 26.3633C32.3292 26.1276 32.1884 25.9171 31.9825 25.8019C30.564 25.0081 28.2475 23.0316 28.1669 20.1561C28.0729 16.805 29.7554 14.1434 31.0288 13.0424C31.3154 12.7946 31.4138 12.3577 31.158 12.0783C29.9994 10.813 27.6686 9.07263 25.542 9.11535C23.9948 9.14643 22.6008 9.72276 21.4046 10.2173C20.4868 10.5967 19.6855 10.928 19.0208 10.928C18.3912 10.928 17.6353 10.5988 16.7678 10.2211C15.5995 9.7123 14.2287 9.11535 12.691 9.11535C9.84268 9.11535 4.21486 11.4773 4.21484 20.5955C4.21484 25.4293 9.20485 35.4996 13.4156 35.3714C14.3248 35.3714 15.2965 34.9949 16.2608 34.6213C17.2103 34.2534 18.1526 33.8883 19.0208 33.8883C19.8591 33.8883 20.806 34.251 21.7631 34.6177Z"
            fill="currentColor"
          />
        </svg>
      ) : (
        <svg
          className={styles.storeIcon}
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.8914 31.1913C10.764 31.3186 10.9165 31.5254 11.075 31.4397C15.1168 29.2534 20.5738 26.2996 25.1856 23.7949C25.2777 23.7448 25.2947 23.6203 25.2199 23.5468L21.9703 20.3471C21.9092 20.287 21.811 20.2873 21.7503 20.3479L10.8914 31.1913Z"
            fill="currentColor"
          />
          <path
            d="M21.7403 16.8275C21.8014 16.888 21.8998 16.8878 21.9606 16.8271L25.2116 13.5791C25.2855 13.5052 25.2674 13.3809 25.1754 13.3312L23.5825 12.4714C21.6672 11.4376 19.1008 10.0526 16.4962 8.6474C14.5456 7.59506 12.5756 6.53251 10.842 5.59796C10.6832 5.51238 10.53 5.71941 10.6581 5.84634L21.7403 16.8275Z"
            fill="currentColor"
          />
          <path
            d="M4.68555 4.99057C4.68555 4.62778 4.74043 4.32405 4.83591 4.07386C4.93458 3.81532 5.26026 3.79551 5.45684 3.99029L20.081 18.4811C20.1426 18.5421 20.1427 18.6415 20.0814 18.7026L5.40399 33.3365C5.18777 33.552 4.83037 33.4999 4.76122 33.2025C4.71102 32.9866 4.68555 32.7472 4.68555 32.49V4.99057Z"
            fill="currentColor"
          />
          <path
            d="M27.6232 22.4691C27.5628 22.5019 27.4881 22.4914 27.4391 22.4432L23.632 18.6957C23.5701 18.6347 23.5698 18.5349 23.6314 18.4737L27.4591 14.6683C27.5081 14.6196 27.5838 14.6092 27.6445 14.6423C30.9025 16.4192 33.444 17.7988 34.2188 18.2087C34.2478 18.224 34.2704 18.2472 34.2834 18.2773C34.3541 18.4403 34.3704 18.6025 34.3464 18.7585C34.3394 18.8035 34.3101 18.8407 34.2698 18.8619C33.8241 19.0968 32.3319 19.9084 30.2533 21.039L30.2406 21.0459C29.4451 21.4786 28.5641 21.9578 27.6232 22.4691Z"
            fill="currentColor"
          />
        </svg>
      )}
      <span className={styles.storeText}>
        Скачать в{' '}
        <strong>{isApple ? 'App Store' : 'Google Play'}</strong>
      </span>
    </div>
  );

  return (
    <a
      href={href}
      className={buttonClass}
      target="_blank"
      rel="noreferrer"
      {...rest}
    >
      {content}
    </a>
  );
};

export default StoreButton;

